<div class="rounded-larger shadow-none p-4">
  <h2 class="text-3xl font-bold text-white">Unser Konzept</h2>
  <ng-container *ngFor="let concept of conceptElems">
    <p class="text-orangeLightX" [innerHtml]="concept.text"></p>
  </ng-container>
</div>
